module.exports = __webpack_public_path__ + "img/opencart.af110934.png";